import React, { useEffect, useState, forwardRef } from 'react';
import classNames from 'classnames';
import { PrimaryButton as Button } from 'jl-design-system/elements/button/Button';
import { CloseOutlined } from 'jl-design-system/components/icons/CloseOutlined';
import { SearchOutlined } from 'jl-design-system/components/icons/SearchOutlined';
import styles from './search-input.scss';

export const SearchInput = forwardRef(
  (
    {
      id,
      searchTerm,
      setSearchTerm,
      loaded,
      loadSearchBoxFiles,
      setLoaded,
      features,
      showClear,
      parentOnFocus,
      isTypeaheadOpen,
    },
    ref
  ) => {
    const placeholderDefaultText = 'Search product or brand';
    const [placeholderText, setPlaceholderText] = useState(
      placeholderDefaultText
    );
    const { box, form, container, results } = ref;

    const searchClassNames = classNames(styles.searchInput, {
      [styles.searchInput__active]: isTypeaheadOpen || showClear,
    });

    useEffect(
      function syncPlaceholderWithTypeahead() {
        if (isTypeaheadOpen) {
          setPlaceholderText();
        } else {
          setPlaceholderText(placeholderDefaultText);
        }
      },
      [isTypeaheadOpen]
    );

    return (
      <div
        className={styles.searchInputContainer}
        data-testid="search-input-container"
      >
        <div
          className={classNames(styles.searchContainer, {
            [styles.searchContainer__active]: isTypeaheadOpen,
          })}
          data-testid="search-container"
        >
          <div className={styles.glassIconContainer}>
            <Button type="submit" className={styles.searchBarButton}>
              <SearchOutlined className={styles.invertedIcon} size="large" />
              <span className={styles.visuallyHidden}>Search</span>
            </Button>
          </div>
          <input
            type="text"
            name="search-term"
            id={id}
            label="Search"
            placeholder={placeholderText}
            maxLength={150}
            autoComplete="off"
            value={searchTerm}
            ref={box}
            onChange={e => {
              setSearchTerm(e.target.value);
            }}
            className={searchClassNames}
            onFocus={() => {
              parentOnFocus();
              if (!loaded) {
                loadSearchBoxFiles(() => {
                  typeof window !== 'undefined' &&
                    window.SearchBoxUI.init(
                      results.current,
                      container.current,
                      form.current,
                      box.current,
                      features.monetateExperiences,
                      true,
                      {}
                    );
                });
              }
              setLoaded(true);
            }}
          />
          <div className={styles.closeIconContainer}>
            <Button
              type="reset"
              className={classNames(styles.searchBarButton, {
                [styles.hide]: !showClear,
              })}
            >
              <CloseOutlined className={styles.invertedIcon} size="large" />
              <span className={styles.visuallyHidden}>Clear</span>
            </Button>
          </div>
        </div>
      </div>
    );
  }
);

SearchInput.displayName = 'SearchInput';
